import React from "react";
import WhyChooseCarousel, {
  toWhyChooseReasons,
} from "../../components/WhyChooseCarousel";
import { whyChooseContent } from "./servicesContent";

/* Same strip the Home page uses, so the question reads identically wherever it
   is asked. These reasons come from this page's approved document as bare
   lines, so they borrow the shared illustrations positionally. */
const ServicesWhyChoose = () => (
  <WhyChooseCarousel
    id="services-why-choose-heading"
    title={whyChooseContent.title}
    reasons={toWhyChooseReasons(whyChooseContent.items)}
    tone="muted"
  />
);

export default ServicesWhyChoose;
